/**
 * Function print the error meesage
 * @param {string} message
 */
export function printMessage(message?: string) {
  if (process.env.REACT_ENABLED_LOG && message) {
    console.error(message);
  }
}
